import type { CityConfig } from "@/pages/city-template/types";

export const rhinebeckConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Rhinebeck",
  state: "New York",
  stateAbbr: "NY",
  slug: "rhinebeck",
  route: "/rhinebeck",
  title: "Emergency Passport Rhinebeck, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rhinebeck, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rhinebeck, Dutchess County Fair, Hudson Valley wine country, SWF/ALB/JFK travelers, and all northern Dutchess County communities.",
  h1: "Emergency & Expedited Passport Services in Rhinebeck, NY",
  heroSubtitle: "Dutchess County Fair vendor heading to a French antiques market next week? Hudson Valley winemaker departing for a Burgundy harvest exchange? Upstate weekender's spontaneous trip to London booked from the Beekman Arms? We help Rhinebeck residents — from historic village shopkeepers to wine country vintners to Red Hook and Tivoli families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20historic%20Rhinebeck%20village%20in%20Dutchess%20County%20New%20York%20with%20charming%20Main%20Street%20lined%20with%20boutique%20shops%20antique%20stores%20and%20restaurants%2C%20Hudson%20Valley%20wine%20country%20with%20vineyards%20and%20rolling%20hills%20in%20autumn%20colors%20of%20gold%20orange%20and%20red%2C%20the%20Beekman%20Arms%20historic%20inn%20visible%2C%20Dutchess%20County%20Fairgrounds%20in%20the%20distance%2C%20warm%20golden%20afternoon%20light%2C%20modern%20editorial%20travel%20photography%20with%20rich%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition%20capturing%20village%20charm%20and%20countryside%20beauty&width=1600&height=700&seq=rhinebeck-hero-v3-001&orientation=landscape",
  heroImageAlt: "Historic Rhinebeck village in Dutchess County with Main Street and Hudson Valley wine country at golden hour",
  geoPosition: "41.9268;-73.9127",
  geoPlacename: "Rhinebeck, New York",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~90 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Rhinebeck", zips: "12572" },
    { name: "Red Hook", zips: "12571" },
    { name: "Tivoli", zips: "12583" },
    { name: "Rhinecliff", zips: "12574" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Millbrook", zips: "12545" },
    { name: "Amenia", zips: "12501" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Staatsburg", zips: "12580" },
    { name: "Milan", zips: "12571" },
    { name: "Pine Plains", zips: "12567" },
    { name: "Kingston", zips: "12401, 12402, 12411, 12429, 12432, 12441, 12449, 12484, 12485, 12487, 12490, 12491, 12492, 12496" },
    { name: "Newburgh", zips: "12550" },
    { name: "Beacon", zips: "12508" },
    { name: "Hudson", zips: "12534" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for the Hudson Valley", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Rhinebeck-area travelers with immediate departures from SWF, ALB, or JFK." },
    { icon: "ri-store-2-line", title: "Antiques, Art & Village Commerce", desc: "Rhinebeck is one of the Hudson Valley's premier shopping and antiques destinations. Dealers and shopkeepers travel internationally for European auctions, trade fairs, and buying trips on famously short notice." },
    { icon: "ri-goblet-line", title: "Hudson Valley Wine Country & Culinary Tourism", desc: "From Millbrook Vineyards to the Culinary Institute nearby, from farm-to-table restaurants to winemaker exchanges in Burgundy — Rhinebeck anchors the Hudson Valley's food and wine culture." },
    { icon: "ri-calendar-event-line", title: "Dutchess County Fair & Seasonal Tourism", desc: "The Dutchess County Fair draws hundreds of thousands each August. The Old Rhinebeck Aerodrome air shows attract international visitors and aviation enthusiasts worldwide." },
  ],
  internalLinks: [
    { name: "Fast passport services in Red Hook, NY", route: "/red-hook" },
    { name: "Expedited passport in Hyde Park, NY", route: "/hyde-park" },
    { name: "Quick passport services in Hudson, NY", route: "/hudson-ny" },
    { name: "Urgent passport services in Poughkeepsie, NY", route: "/poughkeepsie" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Rhinebeck and all of northern Dutchess County via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Rhinebeck residents can ship from any UPS Store, FedEx Office, or post office location across the Hudson Valley.",
  fpcOfficeDistance: "Serving Rhinebeck, Red Hook, Tivoli, Hyde Park, and all Hudson Valley wine country communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rhinebeck and the greater Hudson Valley. From the historic village center to the Dutchess County wine trail, from the Dutchess County Fairgrounds to the Old Rhinebeck Aerodrome — we serve all of northern Dutchess County. Our courier service eliminates the need to drive 90 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Rhinebeck and all surrounding communities including Red Hook, Tivoli, Hyde Park, Staatsburg, Millbrook, and Amenia. We also serve Hudson Valley winemakers, antiques dealers, and weekend residents who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rhinebeck as simple as possible — with the speed village shopkeepers, wine country vintners, and Dutchess County travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rhinebeck travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Rhinebeck travelers encounter unique passport issues — everything from antiques dealer auction travel to wine harvest exchange timelines. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Rhinebeck travelers — from village antiques dealers to Hudson Valley winemakers to weekend residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Rhinebeck, NY? Here are the most common ones we hear from Hudson Valley wine country travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you're a Rhinebeck antiques dealer heading to a Paris auction, a Hudson Valley winemaker traveling to Burgundy for harvest, or a Dutchess County family booking a European vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "European auction notification for a lot closing in 5 days? Family emergency abroad requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Rhinebeck-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rhinebeck residents renew fast — no agency visit required for most renewals. Perfect for village shopkeepers, wine country vintners, and Hudson Valley weekenders.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Rhinebeck residents — from village families to Red Hook newcomers — through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your antiques buying trip or wine harvest exchange is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Dutchess County family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports. Common for Rhinebeck residents and weekend homeowners after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Rhinebeck antiques dealers heading to European auctions while their primary passport is in visa processing for an Asian buying trip.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Wine-stained passports from harvest work, water-damaged documents from Hudson River sailing — damaged passports happen in the Hudson Valley. We guide you through replacement faster than you think.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Rhinebeck travelers heading to Montreal or Quebec wine country.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rhinebeck NY", description: "Urgent passport processing for Rhinebeck NY travelers, antiques dealers, and Hudson Valley winemakers with immediate departure needs." },
    { name: "Expedited Passport Renewal Rhinebeck NY", description: "Fast passport renewal for Rhinebeck NY residents with a previously-issued passport." },
    { name: "First-Time Passport Rhinebeck NY", description: "New passport application services for Rhinebeck NY residents applying for their first passport." },
    { name: "Child Passport Rhinebeck NY", description: "Minor passport services for Rhinebeck NY families with children under 16." },
    { name: "Name Change Passport Rhinebeck NY", description: "Passport name correction after marriage, divorce, or legal name changes for Rhinebeck residents." },
    { name: "Second Passport Rhinebeck NY", description: "Second passport services for Rhinebeck antiques dealers and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Rhinebeck Village, NY",
      rating: 5,
      text: "I run an antiques shop on East Market Street and got word of an estate auction in the UK closing in 6 days. My passport had expired and I had not noticed. Fast Passport Center renewed it in 48 hours. I made the auction and the lot I won covered the service fee ten times over.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert T.",
      location: "Red Hook, NY",
      rating: 5,
      text: "Hudson Valley winemaker heading to Burgundy for harvest exchange. Realized my passport had only 4 months remaining — below the 6-month rule for France. Fast Passport Center expedited a renewal in 4 days. Made it to Burgundy for the first day of harvest.",
      service: "Passport Renewal",
    },
    {
      name: "Diana L.",
      location: "Tivoli, NY",
      rating: 5,
      text: "First-time passport for my daughter's school trip to France. The agent walked us through the DS-11 form and the acceptance clerk process at the Rhinebeck Post Office. Processed in 5 days — met the school's deadline with time to spare.",
      service: "New Passport",
    },
    {
      name: "The Henderson Family",
      location: "Rhinebeck, NY",
      rating: 5,
      text: "Weekend residents from NYC who booked a last-minute trip to Italy from our Rhinebeck house. Discovered my husband's passport expired Friday evening with a Sunday JFK departure. Fast Passport Center expedited it in 48 hours. The Beekman Arms concierge now recommends them to every guest.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "rhinebeck-1",
      name: "Rhinebeck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6387 Mill Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "(845) 876-4031",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Downtown Rhinebeck",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Rhinebeck passport acceptance facility. Extremely busy during summer tourism season (June–September) and Dutchess County Fair week (August). Book 3+ weeks ahead during peak periods.",
      icon: "ri-mail-line",
    },
    {
      id: "rhinebeck-2",
      name: "Red Hook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7460 South Broadway",
      city: "Red Hook",
      state: "NY",
      zip: "12571",
      phone: "(845) 758-8941",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Red Hook — north of Rhinebeck",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for northern Rhinebeck, Red Hook, and Milan residents. Less crowded than Rhinebeck Main during peak tourism season — good alternative.",
      icon: "ri-mail-line",
    },
    {
      id: "rhinebeck-3",
      name: "Hyde Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "424 Albany Post Road",
      city: "Hyde Park",
      state: "NY",
      zip: "12538",
      phone: "(845) 229-8074",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Hyde Park — south of Rhinebeck",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Hyde Park, Staatsburg, and southern Rhinebeck residents. Good backup option during Dutchess County Fair week when Rhinebeck Main is overwhelmed.",
      icon: "ri-mail-line",
    },
    {
      id: "rhinebeck-4",
      name: "Poughkeepsie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "55 Mansion Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "(845) 471-5220",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Poughkeepsie — south of Rhinebeck",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest passport acceptance facility in Dutchess County. Passport photos available on-site. More appointment slots than any other local facility.",
      icon: "ri-mail-line",
    },
    {
      id: "rhinebeck-5",
      name: "Tivoli Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "73 Broadway",
      city: "Tivoli",
      state: "NY",
      zip: "12583",
      phone: "(845) 757-2301",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Tivoli — north of Rhinebeck",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Tivoli, Barrytown, and northern Rhinebeck residents. Small facility — call in advance for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "rhinebeck-6",
      name: "Dutchess County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "22 Market Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "(845) 486-2120",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Poughkeepsie — Dutchess County Office Building",
      website: "https://www.dutchessny.gov/Departments/County-Clerk/Passports.htm",
      websiteLabel: "Dutchess County Clerk",
      notes: "County clerk passport acceptance — excellent for first-time applicants. No passport photos on-site. Convenient for Rhinebeck residents who prefer county office service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 90 miles to Manhattan Passport Agency", fpc: "Most Rhinebeck travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays — critical for antiques dealers with auction deadlines" },
    { feature: "Auction & Trade Fair Travel", agency: "No accommodation for short-notice antiques and wine trade travel", fpc: "We understand auction house timelines and wine harvest exchange deadlines — these trips have 3–7 day booking windows" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Hudson Valley-Specific Guidance", agency: "Generic — no wine country, antiques trade, or Dutchess County Fair expertise", fpc: "Full Hudson Valley wine/antiques/Dutchess County Fair/SWF-ALB-JFK knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Antiques Dealer Auction Travel — 3–7 Day Booking Windows",
      description: "Rhinebeck antiques dealers regularly receive auction house notifications with just days of notice for European lots. Standard passport processing is impossible on these timelines. Our 2–9 day channel exists precisely for auction travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "NYC Weekender Friday Evening Passport Panic",
      description: "Weekend residents from NYC discover expired passports Friday evening in Rhinebeck with a Sunday JFK international departure. This compressed 48-hour weekend timeline requires emergency processing — standard services cannot help.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Dutchess County Fair Week Facility Overload",
      description: "During Dutchess County Fair week (late August), every local acceptance facility is fully booked. Rhinebeck residents needing passport acceptance during fair week should book appointments 3+ weeks in advance or use facilities in Red Hook or Hyde Park.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Wine Harvest Timeline Miscalculation",
      description: "Hudson Valley winemakers traveling to Burgundy or Bordeaux for harvest exchanges in September often wait until July or August to check passport validity — right when local acceptance facilities are at their busiest with summer tourism.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Schengen Area 6-Month Rule",
      description: "Rhinebeck travelers heading to France, Italy, or Spain for wine and antiques trips often do not realize their passport needs 6 months validity beyond the return date. We flag this before submission.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's an auction trip, wine exchange, or family vacation. Complete your secure order in minutes from your home, shop, or vineyard." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist with instructions for the nearest acceptance facility — Rhinebeck Post Office, Red Hook, or wherever is most convenient." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Rhinebeck clients ship from the UPS Store in Poughkeepsie or FedEx in Kingston — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 90 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives within your chosen timeframe. Whether you are bidding at an auction in London or harvesting grapes in Burgundy — your passport is ready." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rhinebeck?", a: "We offer Rhinebeck-area clients — including antiques dealers and Hudson Valley winemakers — expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors." },
    { q: "I am an antiques dealer — can you handle auction travel urgency?", a: "Absolutely. Auction house notifications for European lots often give just 3–7 days before a sale. Our emergency and 2–9 day expedited services are designed specifically for these compressed timelines. We have handled auction travel for Rhinebeck dealers heading to London, Paris, Brussels, and Hong Kong." },
    { q: "Where can I get passport acceptance in Rhinebeck?", a: "The Rhinebeck Post Office (6387 Mill Street) is the primary facility. Nearby alternatives include Red Hook Post Office (7460 South Broadway), Hyde Park Post Office (424 Albany Post Road), and the Poughkeepsie Main Post Office (55 Mansion Street). The Dutchess County Clerk in Poughkeepsie is also an excellent option." },
    { q: "I am a weekend resident from NYC — what if I discover an expired passport on a Friday evening?", a: "This is one of our most common Rhinebeck scenarios. NYC weekenders discover expired passports Friday evening with a Sunday JFK departure. Our 24-hour emergency service can process a renewal before your Sunday flight. Contact us immediately — Friday evening is not too late." },
    { q: "What about the Dutchess County Fair — does it affect passport services?", a: "Yes — during Dutchess County Fair week (late August), every local acceptance facility is overwhelmed with fair-related visitors. Book your passport acceptance appointment 3+ weeks in advance during August, or use facilities outside the immediate fair zone." },
    { q: "Can you help Hudson Valley winemakers with passports?", a: "Yes — we regularly assist Hudson Valley winemakers and vineyard professionals with expedited passports for European harvest exchanges, wine competitions, and Burgundy/Bordeaux collaborations. We understand the seasonal calendar and can coordinate processing around harvest deadlines." },
    { q: "What about the Old Rhinebeck Aerodrome — do aviation enthusiasts travel internationally?", a: "The Old Rhinebeck Aerodrome draws aviation enthusiasts from around the world, and many local volunteers and staff travel to European air shows and aviation museums. We expedite passports for these trips — especially the summer air show season when passports are needed on short notice." },
    { q: "How much does an expedited passport cost in Rhinebeck?", a: "Government fees are $130 + $60 expedite fee. Our courier service fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% less than FedEx, Staples, and other third-party resellers." },
    { q: "Does Fast Passport Center have a Rhinebeck office?", a: "We operate as a remote courier service — no physical office in Rhinebeck, but our overnight shipping network serves Dutchess County efficiently. You can complete everything from your shop on East Market Street, your vineyard, or any local shipping location." },
    { q: "What airports do Rhinebeck travelers use?", a: "SWF (Stewart International, ~25 miles) is closest. ALB (Albany, ~70 miles) and JFK (~85 miles) are the primary international gateways. We coordinate passport timelines around your departure airport and flight date." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rhinebeck Residents",
    intro: "Rhinebeck's identity — a historic Hudson Valley village that doubles as a global antiques destination, wine country anchor, and weekend retreat for New York City's creative class — creates passport timing challenges unlike anywhere else in Dutchess County.",
    cards: [
      {
        icon: "ri-store-2-line",
        title: "Rhinebeck's Antiques & Art Economy — Global Auction Travel",
        subtitle: "One of the Hudson Valley's premier antiques destinations — 30+ dealers and galleries",
        description: "Rhinebeck's village is legendary for antiques and decorative arts. Dealers and gallerists travel internationally year-round for European auctions (Sotheby's, Christie's, Bonhams), trade fairs (BRAFA in Brussels, Biennale in Paris), and estate sales across the UK, France, and Italy. These trips materialize with startling speed — an auction house calls about a lot closing in 5 days, a collector tips off a dealer about an estate, a fair accepts a last-minute exhibitor. The 3–7 day booking-to-departure window is standard in this industry.",
        tip: "Rhinebeck antiques dealers should maintain passports with at least 12 months of validity at all times. Auction dates are fixed and unmovable — a passport renewal in standard processing will never arrive in time for last-minute auction travel.",
      },
      {
        icon: "ri-goblet-line",
        title: "Hudson Valley Wine Country — Harvest Exchange Season",
        subtitle: "Millbrook Vineyards, Clinton Vineyards, and the Dutchess County Wine Trail",
        description: "The Hudson Valley is one of America's oldest wine regions, and Rhinebeck sits at its heart. Winemakers and vineyard professionals travel to Europe annually for harvest exchanges in Burgundy, blending consultations in Bordeaux, and Riesling research in Germany. Harvest season (August–October) is the busiest — and ironically the worst time to discover a passport issue, as local acceptance facilities are overwhelmed with Dutchess County Fair visitors and summer tourists.",
        tip: "Winemakers heading to Europe for harvest should renew passports by June — before summer tourism season peaks and acceptance facilities fill. An August passport emergency during fair week is a worst-case scenario.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF, ALB & JFK — Tri-Airport Hudson Valley Access",
        subtitle: "Stewart International (~25 miles), Albany (~70 miles), JFK (~85 miles)",
        description: "Rhinebeck travelers have three airport options, each with distinct passport implications. Stewart International (SWF) is the closest with the Dublin direct route — popular among Rhinebeck residents for European connections. Albany (ALB) serves domestic hubs. JFK is the global gateway. Rhinebeck's weekend residents from NYC are particularly vulnerable to the JFK timeline trap — they discover an expired passport Friday evening in Rhinebeck with a Sunday JFK departure.",
        tip: "SWF's Aer Lingus Dublin flight requires a valid passport at the Stewart check-in counter — just 25 miles from Rhinebeck. If you are connecting through another U.S. hub, you still need your passport before you leave Dutchess County.",
      },
      {
        icon: "ri-calendar-event-line",
        title: "Dutchess County Fair & Old Rhinebeck Aerodrome — Seasonal Tourism",
        subtitle: "Hundreds of thousands of visitors transform Rhinebeck each August and during air show season",
        description: "The Dutchess County Fair — New York's second-largest county fair — transforms Rhinebeck each August into one of the busiest destinations in the Hudson Valley. The Old Rhinebeck Aerodrome's weekend air shows draw aviation enthusiasts from around the world, with vintage aircraft and WWI-era dogfight reenactments. Both events create seasonal passport demand: fair vendors traveling to European markets, aviation volunteers heading to international air shows, and the general crush of summer tourism overwhelming local services.",
        tip: "Dutchess County Fair week is the single worst time to need an in-person passport acceptance in Rhinebeck. Every local facility is fully booked. If you have international travel plans in August or September, handle your passport acceptance by July.",
      },
    ],
    callout: {
      icon: "ri-home-line",
      title: "The Rhinebeck Weekender Paradox — NYC Proximity, Upstate Passport Infrastructure",
      description: "Rhinebeck's popularity as a weekend destination for New York City's creative class creates a recurring passport emergency: residents discover expired passports Friday evening, have a Sunday JFK flight, and cannot get to Manhattan for a Monday agency appointment. Our 24-hour courier service exists precisely for these compressed weekend timelines.",
    },
  },
  destinations: {
    title: "Where Rhinebeck Travelers Go — And Why Passports Get Urgent",
    intro: "Rhinebeck's antiques trade, wine country character, and weekend-resident culture create a unique international travel profile. Here's what drives passport urgency from the historic village.",
    stats: [
      { stat: "35%", label: "of Rhinebeck expedited requests are antiques/art/auction-related with 3–7 day notice" },
      { stat: "2–4 Weeks", label: "average lead time Rhinebeck dealers have from auction notification to departure" },
      { stat: "Apr–Jun & Aug–Oct", label: "peak seasons when spring auctions, Dutchess County Fair, wine harvest, and fall buying trips converge" },
      { stat: "48 Hours", label: "shortest turnaround for a Rhinebeck antiques dealer heading to a London auction" },
    ],
    destinations: [
      { name: "United Kingdom", context: "London auctions (Sotheby's, Christie's, Bonhams), English antiques buying trips, Beekman Arms heritage connections", urgency: "Auction house notifications give 3–7 days — the most compressed timeline in the Hudson Valley", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Paris flea markets and Biennale, Burgundy wine harvest exchanges, Bordeaux blending consultations", urgency: "Harvest season (Aug–Oct) creates a 6-week passport window — book renewal by June", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Tuscan antiques and wine, Venice Biennale, Millbrook Vineyards Italian varietal research", urgency: "Venice Biennale and Milan Design Fair dates are fixed annually — dealers plan around them", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Rhine wine region research, Berlin gallery scene, Munich antiques, Aerodrome aviation connections", urgency: "Gallery and fair opening dates are fixed — dealers need passports ready for installation week", icon: "ri-map-pin-2-line" },
      { name: "Belgium & Netherlands", context: "Brussels antiques fair (BRAFA), Amsterdam design auctions, Hudson Valley Dutch heritage connections", urgency: "BRAFA and design fair dates create predictable quarterly urgency spikes for dealers", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal and Quebec weekend getaways, Toronto antiques market, cross-border wine tasting trips", urgency: "Weekend trips from the Hudson Valley booked 1–2 weeks out — passport card ideal for land crossings", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Red Hook", route: "/red-hook" },
      { name: "Hyde Park", route: "/hyde-park" },
      { name: "Hudson", route: "/hudson-ny" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Rhinebeck", address: "6700 Route 9, Rhinebeck, NY 12572", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Rhinebeck", address: "6700 Route 9, Rhinebeck, NY 12572", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Rite Aid — Red Hook", address: "7488 South Broadway, Red Hook, NY 12571", hours: "Daily 8 AM – 9 PM", website: "https://www.riteaid.com/" },
    { name: "The UPS Store — Poughkeepsie Plaza", address: "2600 South Road, Poughkeepsie, NY 12601", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Kingston", address: "601 Frank Sottile Boulevard, Kingston, NY 12401", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "FedEx Office — Kingston", address: "1200 Ulster Avenue, Kingston, NY 12401", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Poughkeepsie Main Post Office Photo", address: "55 Mansion Street, Poughkeepsie, NY 12601", hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Poughkeepsie",
      address: "13 Corporate Park Drive, Poughkeepsie, NY 12601",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Wappingers Falls",
      address: "29 Marshall Road, Wappingers Falls, NY 12590",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Wappingers Falls DMV office serving south Dutchess County residents. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "About 25 miles from Rhinebeck",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley's primary airport with direct flights to Dublin and connections to major U.S. hubs. Most convenient for Rhinebeck and Dutchess County travelers.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 70 miles from Rhinebeck",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with domestic and international connections. Alternative for northern Dutchess County travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options for Dutchess County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS DOH Vital Records. Required for estate and legal matters in Dutchess County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dutchess County Clerk at 22 Market Street. Certified copies available for name changes and legal purposes.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dutchess County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/9jd/dutchess/",
    },
  ],
};

export default rhinebeckConfig;